module.exports = __webpack_public_path__ + "static/idehal-complete-ef6141826d137bb602ec6cc1ae9f48a3.jpg";